module.exports = __webpack_public_path__ + "img/message.ab68c919.png";